import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
  output,
  signal,
} from '@angular/core';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

const TWEAKS_STYLE = `
.twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
  max-height:calc(100vh - 32px);display:flex;flex-direction:column;
  background:rgba(250,249,247,.78);color:#29261b;
  -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
  border:.5px solid rgba(255,255,255,.6);border-radius:14px;
  box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
  font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
.twk-panel .twk-hd{display:flex;align-items:center;justify-content:space-between;
  padding:10px 8px 10px 14px;cursor:move;user-select:none}
.twk-panel .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
.twk-panel .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
  width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
.twk-panel .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
.twk-panel .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
  overflow-y:auto;overflow-x:hidden;min-height:0;
  scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
.twk-panel .twk-row{display:flex;flex-direction:column;gap:5px}
.twk-panel .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
.twk-panel .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
  color:rgba(41,38,27,.72)}
.twk-panel .twk-lbl>span:first-child{font-weight:500}
.twk-panel .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
  color:rgba(41,38,27,.45);padding:10px 0 0}
.twk-panel .twk-sect:first-child{padding-top:0}
.twk-panel .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
  background:rgba(0,0,0,.06);user-select:none}
.twk-panel .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
  background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
  transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
.twk-panel .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
  background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
  border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2}
.twk-panel .btn.full-w{appearance:none;width:100%;display:flex;align-items:center;gap:8px;
  height:28px;padding:0 8px;border:.5px solid rgba(0,0,0,.1);border-radius:7px;
  background:rgba(255,255,255,.6);color:inherit;font:inherit;font-weight:500;
  cursor:default;text-align:left;justify-content:flex-start;white-space:nowrap}
.twk-panel .btn.full-w:hover{background:rgba(255,255,255,.85)}
.twk-panel .col.gap-6{display:flex;flex-direction:column;gap:6px}
`;

@Component({
  selector: 'app-tweak-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tweak-section.html',
})
export class TweakSectionComponent {
  readonly label = input<string>('');
}

@Component({
  selector: 'app-tweak-radio',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tweak-radio.html',
})
export class TweakRadioComponent {
  readonly label = input<string>('');
  readonly value = input<string>('');
  readonly options = input<readonly string[]>([]);
  readonly changed = output<string>();

  activeIndex(): number {
    return Math.max(0, this.options().indexOf(this.value()));
  }

  select(o: string): void {
    this.changed.emit(o);
  }
}

@Component({
  selector: 'app-tweaks-panel',
  standalone: true,
  imports: [CdkDrag, CdkDragHandle],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [TWEAKS_STYLE],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './tweaks-panel.html',
})
export class TweaksPanelComponent {
  readonly title = input<string>('Tweaks');
  readonly open = signal(true);
}
